import * as React from 'react';
import { useSelector } from 'react-redux';
import { NewbuildingName } from '../../components/NewbuildingName';
import { getDisplayName, getIsSalesLeader } from '../../selectors/newbuilding';

export function NewbuildingNameContainer() {
  const name = useSelector(getDisplayName);
  const isSalesLeader = useSelector(getIsSalesLeader);

  return <NewbuildingName name={name} isSalesLeader={isSalesLeader} />;
}
